import config from '../../config';
import { authconfig } from '../shared/utils/common';
import axios from 'axios';
import { getCookie } from '../shared/utils/format.helpers';
import { errorOccuredAndLogged_Mixpanel } from '../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE, NETWORK_ISSUE, USER_INPUT_ERROR, NETWORK_ERROR, AUTHENTICATE_USER_SERVICE_API, REFRESH_TOKEN_SERVICE_API, FORGOT_PASSWORD_EMAIL_SERVICE_API, CONFIRM_FORGOT_PASSWORD_SERVICE_API, TEMP_PASSWORD_SERVICE_API, RESET_PASSWORD_SERVICE_API, CREATE_ACCOUNT_SERVICE_API, CREATE_ADMIN_SERVICE_API, APP_ACCESS_TOKEN_SERVICE_CALL } from '../constants/mixPannelConstants';

export const authenticateUserServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  configs.headers = {...configs.headers, 'authorization': `Bearer ${getCookie('_appToken')}`}
  // console.log('CONFIG ', configs)
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/auth`;
  return await axios
    .post(
      url,
      {
        userName: action.payload.username,
        password: action.payload.password,
      },
      { ...configs, timeout: 10000 }
    )
    .then((res) => {
      res.data = { ...(res.data = { ...res.data, userName: action.payload.username }) };
      // console.log('DD22 ',action.payload.username, res)
      return res;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(err, AUTHENTICATE_USER_SERVICE_API, NETWORK_ISSUE);
		} else if (err && err?.response?.data?.message == 'Incorrect username or password.') {
			errorOccuredAndLogged_Mixpanel(err, AUTHENTICATE_USER_SERVICE_API, USER_INPUT_ERROR);
	  	} else {
			errorOccuredAndLogged_Mixpanel(err, AUTHENTICATE_USER_SERVICE_API, CONNECTIVITY_ISSUE);
		}
      	return err;
    });
};

export const refreshTokenServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/token`;
  return await axios
    .post(
      url,
      {
        userName: action.payload.username,
        emailAddress: action.payload.emailAddress,
      },
      {
        headers: {
          ...configs?.headers,
          refreshToken: action.payload.refreshToken,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
	  		errorOccuredAndLogged_Mixpanel(err, REFRESH_TOKEN_SERVICE_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(err, REFRESH_TOKEN_SERVICE_API, CONNECTIVITY_ISSUE);
		}
      return err;
    });
};

export const forgotPasswordEmailServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  configs.headers = {...configs.headers, 'authorization': `Bearer ${getCookie('_appToken')}`}
  // console.log('CONFIG FF ', configs)
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/OTP`;
  return await axios
    .post(
      url,
      {
        userName: action.payload.userName,
      },
      {
        headers: {
          ...configs?.headers,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
	  		errorOccuredAndLogged_Mixpanel(err, FORGOT_PASSWORD_EMAIL_SERVICE_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(err, FORGOT_PASSWORD_EMAIL_SERVICE_API, CONNECTIVITY_ISSUE);
		}
      return err?.response;
    });
};

export const confirmForgotPasswordServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  configs.headers = {...configs.headers, 'authorization': `Bearer ${getCookie('_appToken')}`}
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/reset/OTP`;

  return await axios
    .post(
      url,
      {
        userName: action.payload.username,
        password: action.payload.password,
        confirmationCode: action.payload.token,
      },
      {
        headers: {
          ...configs?.headers,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
	  		errorOccuredAndLogged_Mixpanel(err, CONFIRM_FORGOT_PASSWORD_SERVICE_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(err, CONFIRM_FORGOT_PASSWORD_SERVICE_API, CONNECTIVITY_ISSUE);	
		}
      return { msg: err?.response?.data?.message };
    });
};

export const tempPasswordServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  configs.headers = {...configs.headers, 'authorization': `Bearer ${getCookie('_appToken')}`}
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/update`;
  return await axios
    .post(
      url,
      {
        token: action.payload.token,
        password: action.payload.password,
      },
      {
        headers: {
          ...configs?.headers,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(err, TEMP_PASSWORD_SERVICE_API, NETWORK_ISSUE);
	  	} else {
			errorOccuredAndLogged_Mixpanel(err, TEMP_PASSWORD_SERVICE_API, CONNECTIVITY_ISSUE);	
	  	}
      return err?.response;
    });
};

export const resetPasswordServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  // configs.headers = {...configs.headers, 'Authorization': `Bearer ${getCookie('_appToken')}`}
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/reset`;
  return await axios
    .post(
      url,
      {
        oldPassword: action.payload.oldPassword,
        newPassword: action.payload.newPassword,
      },
      {
        headers: {
          ...configs?.headers,
          accessToken: action.accessToken,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(err, RESET_PASSWORD_SERVICE_API, NETWORK_ISSUE);
	  	} else {
			errorOccuredAndLogged_Mixpanel(err, RESET_PASSWORD_SERVICE_API, CONNECTIVITY_ISSUE);
	  	}
      return err?.response;
    });
};

export const createAccountServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/accounts/new`;
	// console.log('CONFIG ', configs)
  return await axios
    .post(
      url,
      {
        userName: action.payload.userName,
        emailId: action.payload.emailId,
        brandId: action.payload.brandId,
        brandName: action.payload.brandName,
        aggregator: action.payload.aggregator,
      },
      {
        headers: {
          ...configs?.headers,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
	  if (err?.message === NETWORK_ERROR) {
		errorOccuredAndLogged_Mixpanel(err, CREATE_ACCOUNT_SERVICE_API, NETWORK_ISSUE);
	  } else {
		errorOccuredAndLogged_Mixpanel(err, CREATE_ACCOUNT_SERVICE_API, CONNECTIVITY_ISSUE);
	  }
      return err?.response;
    });
};

export const createAdminServiceAPI = async (action) => {
  let configs = authconfig(config.env, 'merchant');
  const url = process.env.MERCHANT_SERVICE_API + `/merchants/admins/accounts/new`;
  return await axios
    .post(
      url,
      {
        userName: action.payload.userName,
        emailId: action.payload.emailId,
        brandId: '',
        brand: '',
        aggregator: '',
      },
      {
        headers: {
          ...configs?.headers,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
	  if (err?.message === NETWORK_ERROR) {
		errorOccuredAndLogged_Mixpanel(err, CREATE_ADMIN_SERVICE_API, NETWORK_ISSUE);
	  } else {
		errorOccuredAndLogged_Mixpanel(err, CREATE_ADMIN_SERVICE_API, CONNECTIVITY_ISSUE);
	  }
      return err?.response;
    });
};

export const getAppAccessTokenServiceCall = async (action) => {
  const clientId = process.env.CLIENT_ID;
  const clientSecret = process.env.CLIENT_SECRET;
  const scope = 'merchant/write';
  const credentials = btoa(`${clientId}:${clientSecret}`);
  let configs = authconfig(config.env, 'merchant');
  const headers = {
    ...configs.headers,
    Authorization: `Basic ${credentials}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  }; 
  const body = new URLSearchParams({
    grant_type: 'client_credentials',
    scope: scope,
  });
  const url = process.env.MERCHANT_SERVICE_AUTH + `/oauth2/token`;
  return await axios.post(url, body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
		if (err?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(err, APP_ACCESS_TOKEN_SERVICE_CALL, NETWORK_ISSUE);
		  } else {
			errorOccuredAndLogged_Mixpanel(err, APP_ACCESS_TOKEN_SERVICE_CALL, CONNECTIVITY_ISSUE);
		  }
      	return err?.response;
    });
};
